import React from 'react';
import { useForm } from 'react-final-form';

import ButtonGroup from '../../ButtonGroup/ButtonGroup';
import CTAButton from '../../CTAButton/CTAButton';

import { TXTWCL_Continue, TXTWCL_Search_again } from './OccupationButtons.messages.json';

interface Props {
  onSearchAgainClick: React.Dispatch<React.SetStateAction<boolean>>;
}

const OccupationButtons: React.FC<Props> = ({ onSearchAgainClick }) => {
  const form = useForm();

  const handleSearchAgainClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    form.resetFieldState('profession');
    form.change('profession', undefined);
    onSearchAgainClick(true);
    e.preventDefault();
  };

  return (
    <ButtonGroup>
      <CTAButton translation={TXTWCL_Continue} />
      <CTAButton
        translation={TXTWCL_Search_again}
        variant="secondary"
        onClick={handleSearchAgainClick}
      />
    </ButtonGroup>
  );
};

OccupationButtons.displayName = 'OccupationButtons';

export default OccupationButtons;
